/**
 * Resolver for tool-declared display text (labels, help, input-slot names).
 *
 * A plugged-in module declares its strings either as a plain string or as a
 * bilingual dict ({"fr": "...", "en": "..."}). Every place that renders
 * tool-declared text goes through `resolveText` so the declaration shape
 * never leaks into components.
 *
 * Resolution order for a dict: exact language tag → 2-letter prefix →
 * "fr" → "en" → first declared value → "".
 */
import type { LocalizedText } from "./api";

export function resolveText(
  value: LocalizedText | undefined | null,
  lang: string,
): string {
  if (value == null) return "";
  if (typeof value === "string") return value;
  const candidates = [lang, lang.slice(0, 2), "fr", "en"];
  for (const key of candidates) {
    const hit = value[key];
    if (typeof hit === "string" && hit !== "") return hit;
  }
  for (const hit of Object.values(value)) {
    if (typeof hit === "string" && hit !== "") return hit;
  }
  return "";
}
